import React from "react";
import { useMagnetic } from "../hooks/useMagnetic";
import { cn } from "../lib/utils";

export const MagneticButton = React.forwardRef(function MagneticButton(
  { children, className, as: Tag = "button", strength = 0.28, radius = 110, ...rest },
  externalRef
) {
  const ref = useMagnetic(strength, radius);
  const setRefs = (node) => {
    ref.current = node;
    if (typeof externalRef === "function") externalRef(node);
    else if (externalRef) externalRef.current = node;
  };
  return (
    <Tag
      ref={setRefs}
      data-magnetic="true"
      className={cn("inline-flex items-center justify-center transition-colors will-change-transform", className)}
      {...rest}
    >
      <span className="inline-flex items-center justify-center pointer-events-none">{children}</span>
    </Tag>
  );
});
